import async from 'async';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { validateEmail } from '../../libs/utility';

import { default as Button, default as IconButton } from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import DeleteIcon from '@material-ui/icons/Delete';
import BulkInvoiceContainer from '../../containers/accounting/BulkInvoice';
import FMPText from '../pureForm/FMPText';
import FMPSectionHeader from '../ui/FMPSectionHeader';
import GenericSavingDialog from './GenericSavingDialog';
import Transition from './Transition';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		maxWidth: '100%',
		width: 800,
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	submitButton: {
		fontSize: 18,
		borderRadius: '100px',
		padding: '20px 30px',
		textTransform: 'uppercase',
	},
	addInputButton: {
		borderRadius: '100px',
		marginTop: 20,
	},
	attachment: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		border: '1px solid #ddd',
	},
	emailBody: {
		border: '1px solid #ddd',
	},
	invoiceDocuments: {
		display: 'flex',
		flexWrap: 'wrap',
		alignContent: 'stretch',
		justifyContent: 'space-between',
		marginTop: 20,
	},
	invoicePage: {
		width: '33%',
		padding: 5,
		boxSizing: 'border-box',
	},
	invoicePageImg: {
		width: '100%',
		height: '100%',
		border: '1px solid #ddd',
	},
	pageSection: {
		borderBottom: '2px dashed #ccc',
		marginBottom: 30,
		paddingBottom: 30,
	},
});

class BulkInvoiceSendConfirmationDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			bulkInvoiceId: undefined,
			additionalInvoiceEmails: [],
			formFieldError: {},
			emailNote: '',
			isSavingOpen: false,
			savingStatus: undefined,
		};
	}

	componentDidUpdate(prevProps, prevState) {
		const { getBulkInvoiceEmailInfo, showErrors } = this.props;

		if (_.isUndefined(prevProps.bulkInvoice) && !_.isUndefined(this.props.bulkInvoice)) {
			const { additionalInvoiceEmails } = this.props.bulkInvoice;
			this.setState({ additionalInvoiceEmails });
		}

		//- Every time it opens get the email info
		if (!prevProps.open && this.props.open && this.props.bulkInvoice) {
			const { bulkInvoiceId } = this.props.bulkInvoice;

			getBulkInvoiceEmailInfo({
				params: { bulkInvoiceId },
				callback: (err, r) => {
					if (err) {
						return showErrors([err]);
					}
					if (!r) {
						return showErrors(['No result from getEmailInfo']);
					}

					const { subject, emailBody } = r;
					if (!subject || !emailBody) {
						return showErrors(['Missing subject or body']);
					}

					this.setState({ subject, emailBody });
				},
			});
		}

		if (prevState.emailNote !== this.state.emailNote) {
			if (this.state.emailNote) {
				const container = document.getElementById('emailNoteContainer');
				if (container) {
					container.style.display = 'block';
				}
			} else {
				const container = document.getElementById('emailNoteContainer');
				if (container) {
					container.style.display = 'none';
				}
			}

			const div = document.getElementById('emailNote');
			if (div) {
				div.innerHTML = this.state.emailNote;
				div.textContent = this.state.emailNote;
			}
		}
	}

	addInput = (arrayName) => {
		this.setState({ [arrayName]: this.state[arrayName].concat(['']) });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	handleClose = () => {
		this.props.onClose();
	};

	handleSendInvoice = () => {
		const { bulkInvoice, sendBulkInvoice, showErrors } = this.props;

		const { additionalInvoiceEmails, emailNote } = this.state;

		const formFieldError = {};
		additionalInvoiceEmails.forEach((email, i) => {
			if (validateEmail(email)) {
				return;
			}
			_.set(formFieldError, ['additionalInvoiceEmails', i], 'Invalid characters in email');
		});

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({
			isSavingOpen: true,
			savingStatus: 'activating',
		});

		const { bulkInvoiceId } = bulkInvoice;
		const params = {
			bulkInvoiceId,
		};

		if (!_.isEmpty(additionalInvoiceEmails)) {
			params.additionalInvoiceEmails = additionalInvoiceEmails;
		}
		if (emailNote) {
			params.emailNote = emailNote;
		}

		setTimeout(() => {
			async.waterfall(
				[
					(callback) => {
						sendBulkInvoice({
							params,
							callback,
						});
					},
				],
				(err) => {
					//- error popup is already shown
					if (err) {
						this.setState({ isSavingOpen: false });
						return showErrors([err]);
					}
					this.setState({ savingStatus: 'done' });
				}
			);
		}, 1000);
	};

	renderErrorDialog = (error) => {
		const { classes, fullScreen } = this.props;
		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth="md"
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>Error Encountered</DialogTitle>
				</div>
				<DialogContent>{error}</DialogContent>
			</Dialog>
		);
	};

	renderInfoDialog = (info) => {
		const { classes, fullScreen } = this.props;
		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth="md"
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>Loading info</DialogTitle>
				</div>
				<DialogContent>{info}</DialogContent>
			</Dialog>
		);
	};

	onChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;

		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	closeSavingDialog = () => {
		this.setState({ onContinue: false });
	};

	continueSavingDialog = () => {
		this.props.history.push(`/accounting/bulkInvoices/issued`);
	};

	render() {
		const {
			classes,
			bulkInvoice,
			bulkCustomerMap,
			bulkFormulaMap,
			fullScreen,
			open,
			invoiceDocumentMap,
			resourceMap,
			quickbooksCustomerMap,
		} = this.props;

		const { additionalInvoiceEmails, subject, emailBody } = this.state;

		if (!open) {
			if (!bulkInvoice || !subject || !emailBody) {
				return null;
			}
		} else {
			if (!bulkInvoice || !subject || !emailBody) {
				this.renderInfoDialog('Loading info...');
			}
		}

		const {
			printableUrl,
			printableFormulaUrl,
			printableLcfsTransferUrl,
			bulkCustomerId,
			invoiceDocumentIds,
		} = bulkInvoice;
		const { isSavingOpen, savingStatus } = this.state;

		const bulkCustomer = bulkCustomerMap[bulkCustomerId];
		if (!bulkCustomer) {
			return this.renderErrorDialog('Missing bulk customer');
		}

		const {
			bulkFormulaId,
			invoiceQuickbooksCustomerId,
			invoiceEmails,
			requirePricingPerInvoice,
		} = bulkCustomer;
		if (!invoiceQuickbooksCustomerId) {
			return this.renderErrorDialog('Bulk customer not linked to quickbooks customer');
		}

		const quickbooksCustomer = quickbooksCustomerMap[invoiceQuickbooksCustomerId];
		if (!quickbooksCustomer) {
			return this.renderErrorDialog('Could not lookup quickbooks customer');
		}

		if (_.isEmpty(invoiceEmails)) {
			return this.renderErrorDialog('Bulk customer needs at least one invoice email');
		}

		let isSeaport = false;
		if (!requirePricingPerInvoice) {
			const bulkFormula = bulkFormulaMap[bulkFormulaId];
			if (!bulkFormula) {
				return this.renderErrorDialog(`Missing bulk formula : ${bulkFormulaId}`);
			}

			const { bulkFormulaKey } = bulkFormula;
			isSeaport = bulkFormulaKey === 'seaportRefining';
		}

		const isLcfsTransfer = false;

		const invoicePages = [];
		if (!_.isEmpty(invoiceDocumentIds)) {
			invoiceDocumentIds.forEach((invoiceDocumentId) => {
				const invoiceDocument = invoiceDocumentMap[invoiceDocumentId] || {
					isMissing: true,
					pageResourceIds: [],
				};

				const { pageResourceIds } = invoiceDocument;
				pageResourceIds.forEach((resourceId, i) => {
					const resource = resourceMap[resourceId] || { isMissing: true };

					invoicePages.push({
						url: resource.url,
						pageNumber: i + 1,
					});
				});
			});
		}

		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth="md"
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>Verify and Send Invoice</DialogTitle>
					<DialogContent>
						<FMPSectionHeader label={'Invoice Email Recipients'} />
						<div>
							{invoiceEmails.map((n, i) => {
								return (
									<div style={{ paddingTop: 3 }} key={i}>
										{n}
									</div>
								);
							})}
						</div>

						{additionalInvoiceEmails.map((email, i) => {
							const path = `additionalInvoiceEmails.${i}`;
							return (
								<Grid container spacing={2} key={i}>
									<FMPText
										label={'Email'}
										path={path}
										value={this.getValue(path)}
										error={this.getError(path)}
										onChange={this.onChange}
										md={6}
										contained={false}
									/>
									<Grid item xs={1} md={1} style={{ display: 'flex' }}>
										<IconButton
											color="primary"
											aria-label="Delete"
											onClick={() => this.removeInput('additionalInvoiceEmails', i)}
										>
											<DeleteIcon />
										</IconButton>
									</Grid>
								</Grid>
							);
						})}

						<div style={{ display: 'flex' }}>
							<Button
								variant="contained"
								className={classes.addInputButton}
								onClick={() => this.addInput('additionalInvoiceEmails')}
							>
								ADD ADDITIONAL INVOICE EMAIL
							</Button>
						</div>

						<br />
						<FMPText
							label={'Email Note'}
							path={'emailNote'}
							value={this.getValue('emailNote')}
							error={this.getError('emailNote')}
							multiline={2}
							onChange={this.onChange}
						/>

						<FMPSectionHeader label={'Email Subject'} />
						<div>{subject}</div>

						<FMPSectionHeader label={'Email Body'} />
						<div className={classes.emailBody}>
							<div dangerouslySetInnerHTML={{ __html: emailBody }} />
						</div>

						<FMPSectionHeader label={'Invoice Attachments'} />

						<div
							style={{
								marginTop: 20,
								width: '100%',
								paddingBottom: '129.4%',
								position: 'relative',
							}}
						>
							<iframe
								frameBorder="0"
								title={'Printable Invoice'}
								className={classes.attachment}
								src={printableUrl}
							/>
						</div>

						{isLcfsTransfer && (
							<div
								style={{
									marginTop: 20,
									width: '100%',
									paddingBottom: '129.4%',
									position: 'relative',
								}}
							>
								<iframe
									frameBorder="0"
									title={'Printable LCFS Transfer'}
									className={classes.attachment}
									src={printableLcfsTransferUrl}
								/>
							</div>
						)}

						{isSeaport && (
							<div
								style={{
									marginTop: 20,
									width: '100%',
									paddingBottom: '129.4%',
									position: 'relative',
								}}
							>
								<iframe
									frameBorder="0"
									title={'Printable Formula'}
									className={classes.attachment}
									src={printableFormulaUrl}
								/>
							</div>
						)}

						<div className={classes.invoiceDocuments}>
							{invoicePages.map((invoicePage, i) => {
								const { url } = invoicePage;

								return (
									<div key={i} className={classes.invoicePage}>
										<img
											alt={`Delivery document page ${i}`}
											src={url}
											className={classes.invoicePageImg}
										/>
									</div>
								);
							})}
						</div>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose}>Cancel</Button>
						<Button
							disabled={isSavingOpen}
							variant="contained"
							onClick={this.handleSendInvoice}
							className={classes.submitButton}
							color="primary"
						>
							Email invoice &amp; import to quickbooks
						</Button>
					</DialogActions>
				</div>

				<GenericSavingDialog
					open={isSavingOpen}
					onClose={this.closeSavingDialog}
					onContinue={this.continueSavingDialog}
					processingText={
						'Generating invoice, collating pages, sending emails, importing to quickbooks...'
					}
					successText={'Invoice emails sent and imported to quickbooks successfully.'}
					status={savingStatus}
				/>
			</Dialog>
		);
	}
}

BulkInvoiceSendConfirmationDialog.propTypes = {
	bulkInvoice: PropTypes.object,
	bulkFormulaMap: PropTypes.object,

	sendBulkInvoice: PropTypes.func.isRequired,
	bulkCustomerMap: PropTypes.object,

	invoiceDocumentMap: PropTypes.object,
	resourceMap: PropTypes.object,
	quickbooksCustomerMap: PropTypes.object,
	getBulkInvoiceEmailInfo: PropTypes.func,

	classes: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	fullScreen: PropTypes.bool.isRequired,
	showErrors: PropTypes.func,
	history: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog(), BulkInvoiceContainer])(
	BulkInvoiceSendConfirmationDialog
);
